import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Info } from 'lucide-react';
import { ServiceConfig } from '../../utils/serviceKeys';
import Dialog from '../Dialog'; // Import the Dialog component
import AboutContent from '../About/AboutContent'; // Placeholder for About content
import TermsContent from '../../pages/TermsPageContent'; // Placeholder for Terms content
import PrivacyContent from '../../pages/PrivacyPageContent'; // Placeholder for Privacy content

interface FooterProps {
  serviceConfig: ServiceConfig;
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ serviceConfig, className = '' }) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const serviceName = serviceConfig.serviceName || 'mythos365';
  
  // Extract service key from the URL path
  const extractServiceKeyFromUrl = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    return pathSegments.length > 0 ? pathSegments[0] : 'default';
  };
  
  const serviceKey = extractServiceKeyFromUrl();

  const [isAboutDialogOpen, setIsAboutDialogOpen] = useState(false);
  const [isTermsDialogOpen, setIsTermsDialogOpen] = useState(false);
  const [isPrivacyDialogOpen, setIsPrivacyDialogOpen] = useState(false);
  return (
    <footer className={`bg-background-paper border-t border-border px-4 py-3 ${className}`}>
      <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center text-foreground-muted text-sm">
        <span>&copy; {currentYear} mythos365.com All rights reserved. v1.6.1</span>
        <button
          onClick={() => setIsAboutDialogOpen(true)}
          className="flex items-center gap-1 text-foreground-muted hover:text-primary transition-colors"
        >
          <Info className="h-4 w-4" aria-hidden="true" />
          <span>About Us</span>
        </button>
        <button
          onClick={() => setIsTermsDialogOpen(true)}
          className="text-foreground-muted hover:text-primary transition-colors"
        >
          Terms of Service
        </button>
        <button
          onClick={() => setIsPrivacyDialogOpen(true)}
          className="text-foreground-muted hover:text-primary transition-colors"
        >
          Privacy Policy
        </button>
      </div>

      <Dialog isOpen={isAboutDialogOpen} onClose={() => setIsAboutDialogOpen(false)} title="About Us">
        <AboutContent serviceConfig={serviceConfig} />
      </Dialog>

      <Dialog isOpen={isTermsDialogOpen} onClose={() => setIsTermsDialogOpen(false)} title="Terms of Service">
        <TermsContent serviceKey={serviceKey} />
      </Dialog>

      <Dialog isOpen={isPrivacyDialogOpen} onClose={() => setIsPrivacyDialogOpen(false)} title="Privacy Policy">
        <PrivacyContent serviceKey={serviceKey} />
      </Dialog>
    </footer>
  );
};

export default Footer;
